import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { TraxcnCompanies } from '@/features/traxcn-companies'

const searchSchema = z.object({
  page:          z.number().optional().catch(1),
  pageSize:      z.number().optional().catch(50),
  filter:        z.string().optional().catch(''),
  stages:        z.array(z.string()).optional().catch([]),
  countries:     z.array(z.string()).optional().catch([]),
  cities:        z.array(z.string()).optional().catch([]),
  foundedYears:  z.array(z.number()).optional().catch([]),
  sectors:       z.array(z.string()).optional().catch([]),
  flags:         z.array(z.string()).optional().catch([]),
  investors:     z.array(z.string()).optional().catch([]),
  fundingRanges: z.array(z.string()).optional().catch([]),
  empRanges:     z.array(z.string()).optional().catch([]),
  xcornRatings:  z.array(z.string()).optional().catch([]),
  tags:          z.array(z.string()).optional().catch([]),
  tagsMode:      z.enum(['any', 'all']).optional().catch('any'),
  adapterStatus: z.enum(['all', 'with', 'without']).optional().catch(undefined),
  sortColumn:    z.string().optional(),
  sortDir:       z.enum(['asc', 'desc']).optional(),
  companyId:     z.string().optional(),
})

export type TraxcnCompaniesSearchParams = z.infer<typeof searchSchema>

export const Route = createFileRoute('/_authenticated/company-intelligence/')({
  validateSearch: searchSchema,
  component: TraxcnCompanies,
})
